import React, { createContext, useContext } from 'react';
import { useSidebarNavigation } from '@app/hooks/useSidebarNavigation';
import { SidebarNavigationItem } from '@app/components/layouts/main/sider/sidebarNavigation';

interface NavigationContextValue {
  navigation: SidebarNavigationItem[];
  loading: boolean;
  error: string | null;
  refetch: () => Promise<void>;
}

const NavigationContext = createContext<NavigationContextValue>({
  navigation: [],
  loading: false,
  error: null,
  refetch: async () => undefined,
});

export const NavigationProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const value = useSidebarNavigation();
  return (
    <NavigationContext.Provider value={value}>
      {children}
    </NavigationContext.Provider>
  );
};

export const useNavigationContext = (): NavigationContextValue =>
  useContext(NavigationContext);
